export function normalizeEmail(value: string): string {
  const email = value.trim().toLowerCase();
  if (email.length > 320 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    throw new Error('Email inválido.');
  }
  return email;
}

export function passwordValidationError(password: string, confirmation: string): string {
  if (password.length < 12) return 'La contraseña debe tener al menos 12 caracteres.';
  if (password !== confirmation) return 'Las contraseñas no coinciden.';
  return '';
}

export type AuthEventAction = 'full' | 'silent';

/**
 * Decide cómo reaccionar a un evento de `supabase.auth.onAuthStateChange`.
 *
 * supabase-js re-emite `SIGNED_IN` cada vez que la pestaña vuelve a estar
 * visible (al volver de Gmail, Word, otra pestaña…) y `TOKEN_REFRESHED` cuando
 * renueva el JWT. Ninguno de los dos implica un usuario distinto. Si el usuario
 * del evento es el mismo que ya está resuelto, no hay nada que recargar: pasar
 * por `loading` desmonta toda la app y se pierden formularios a medio escribir
 * y filtros de dashboards.
 *
 * - `silent`: mismo usuario (o sigue sin haber usuario) → sólo refrescar
 *   metadata, sin `loading` ni refetch de perfil.
 * - `full`: login, logout o cambio de usuario → resolver perfil con `loading`.
 */
export function authEventAction(nextUserId: string | null, resolvedUserId: string | null): AuthEventAction {
  return nextUserId === resolvedUserId ? 'silent' : 'full';
}
